import { render, staticRenderFns } from "./PotencyTerpenes.template.vue?vue&type=template&id=50c5bc58&scoped=true&"
var script = {}
import style0 from "./PotencyTerpenes.template.vue?vue&type=style&index=0&id=50c5bc58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5bc58",
  null
  
)

export default component.exports